// TrialOverlay — locks the canvas when the trial expired and the user is not PRO.
// CTAs: Stripe lifetime checkout + R₿L on-chain payment (-50%).
import React from "react";
import { Lock, Home } from "lucide-react";
import { Link } from "react-router-dom";
import { tLm } from "../../i18n/liqmap";
import { useLanguage } from "../../i18n/LanguageContext";
import RBLPaymentButton from "../pro/RBLPaymentButton";
import { API_BASE } from "../../lib/api";

export default function TrialOverlay() {
  const { lang } = useLanguage();
  const t = tLm(lang).trial;

  const goStripe = () => {
    // Use the same flow as PremiumGate / BannerOferta — redirect to Stripe Checkout.
    window.location.href = `${API_BASE}/api/payments/checkout`;
  };

  // Render strong word inside the title.
  const title = t.expired_title.split(t.expired_strong);

  return (
    <div
      className="absolute inset-0 z-30 flex items-center justify-center"
      style={{ background: "rgba(8,5,8,0.93)", backdropFilter: "blur(10px)" }}
      data-testid="liqmap-trial-overlay"
    >
      <div className="w-full max-w-md px-6 text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full border border-[#f97316]/40 bg-[#f97316]/[0.12]">
          <Lock className="h-7 w-7 text-[#f97316]" />
        </div>
        <h2 className="text-xl font-black tracking-tight text-white sm:text-2xl">
          {title[0]}
          <span style={{ color: "#f97316" }}>{t.expired_strong}</span>
          {title[1]}
        </h2>
        <p className="mt-2 text-sm text-white/60">{t.expired_sub}</p>

        <button
          onClick={goStripe}
          data-testid="liqmap-cta-lifetime"
          className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-2xl px-6 py-3.5 text-sm font-black uppercase tracking-[0.16em] text-white transition-all hover:-translate-y-0.5"
          style={{
            background: "linear-gradient(135deg, #f97316, #ea580c)",
            boxShadow: "0 0 24px rgba(249,115,22,0.5)",
          }}
        >
          {t.cta_lifetime}
        </button>

        <div className="mt-3" data-testid="liqmap-cta-rbl-wrap">
          <RBLPaymentButton />
        </div>

        <p className="mt-3 font-mono text-[10px]" style={{ color: "#444" }}>
          {t.lifetime_note}
        </p>

        <Link
          to="/"
          data-testid="liqmap-cta-back"
          className="mt-4 inline-flex items-center justify-center gap-2 rounded-full border border-white/[0.08] bg-transparent px-5 py-2 font-mono text-[11px] uppercase tracking-[0.18em] transition-colors hover:border-white/20"
          style={{ color: "#555" }}
        >
          <Home className="h-3 w-3" /> {t.cta_back}
        </Link>
      </div>
    </div>
  );
}
